var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVioletCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2110_98724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 3.97925H21.75C22.5784 3.97925 23.25 4.65082 23.25 5.47925V21.9792C23.25 22.8077 22.5784 23.4792 21.75 23.4792H2.25C1.42157 23.4792 0.75 22.8077 0.75 21.9792V5.47925C0.75 4.65082 1.42157 3.97925 2.25 3.97925Z",
    stroke: "#C0B7D1",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 9.97925H0.75",
    stroke: "#C0B7D1",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 6.22925V0.979248",
    stroke: "#C0B7D1",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.22925V0.979248",
    stroke: "#C0B7D1",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375 13.7292C18.4492 13.7292 18.5217 13.7512 18.5833 13.7924C18.645 13.8337 18.6931 13.8922 18.7215 13.9607C18.7498 14.0293 18.7573 14.1047 18.7428 14.1774C18.7283 14.2502 18.6926 14.317 18.6402 14.3694C18.5877 14.4219 18.5209 14.4576 18.4482 14.472C18.3754 14.4865 18.3 14.4791 18.2315 14.4507C18.163 14.4223 18.1044 14.3743 18.0632 14.3126C18.022 14.2509 18 14.1784 18 14.1042C18 14.0048 18.0395 13.9094 18.1098 13.8391C18.1802 13.7688 18.2755 13.7292 18.375 13.7292Z",
    fill: "#C0B7D1",
    stroke: "#C0B7D1",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375 18.9792C18.4492 18.9792 18.5217 19.0012 18.5833 19.0424C18.645 19.0837 18.6931 19.1422 18.7215 19.2107C18.7498 19.2793 18.7573 19.3547 18.7428 19.4274C18.7283 19.5001 18.6926 19.567 18.6402 19.6194C18.5877 19.6719 18.5209 19.7076 18.4482 19.722C18.3754 19.7365 18.3 19.7291 18.2315 19.7007C18.163 19.6723 18.1044 19.6243 18.0632 19.5626C18.022 19.5009 18 19.4284 18 19.3542C18 19.2548 18.0395 19.1594 18.1098 19.0891C18.1802 19.0188 18.2755 18.9792 18.375 18.9792Z",
    fill: "#C0B7D1",
    stroke: "#C0B7D1",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.7292C12.0742 13.7292 12.1467 13.7512 12.2083 13.7924C12.27 13.8337 12.3181 13.8922 12.3465 13.9607C12.3748 14.0293 12.3823 14.1047 12.3678 14.1774C12.3533 14.2502 12.3176 14.317 12.2652 14.3694C12.2127 14.4219 12.1459 14.4576 12.0732 14.472C12.0004 14.4865 11.925 14.4791 11.8565 14.4507C11.788 14.4223 11.7294 14.3743 11.6882 14.3126C11.647 14.2509 11.625 14.1784 11.625 14.1042C11.625 14.0048 11.6645 13.9094 11.7348 13.8391C11.8052 13.7688 11.9005 13.7292 12 13.7292Z",
    fill: "#C0B7D1",
    stroke: "#C0B7D1",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.9792C12.0742 18.9792 12.1467 19.0012 12.2083 19.0424C12.27 19.0837 12.3181 19.1422 12.3465 19.2107C12.3748 19.2793 12.3823 19.3547 12.3678 19.4274C12.3533 19.5001 12.3176 19.567 12.2652 19.6194C12.2127 19.6719 12.1459 19.7076 12.0732 19.722C12.0004 19.7365 11.925 19.7291 11.8565 19.7007C11.788 19.6723 11.7294 19.6243 11.6882 19.5626C11.647 19.5009 11.625 19.4284 11.625 19.3542C11.625 19.2548 11.6645 19.1594 11.7348 19.0891C11.8052 19.0188 11.9005 18.9792 12 18.9792Z",
    fill: "#C0B7D1",
    stroke: "#C0B7D1",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 13.7292C5.69917 13.7292 5.77167 13.7512 5.83334 13.7924C5.89501 13.8337 5.94307 13.8922 5.97145 13.9607C5.99984 14.0293 6.00726 14.1047 5.99279 14.1774C5.97832 14.2502 5.94261 14.317 5.89017 14.3694C5.83772 14.4219 5.7709 14.4576 5.69816 14.472C5.62542 14.4865 5.55002 14.4791 5.48149 14.4507C5.41297 14.4223 5.3544 14.3743 5.3132 14.3126C5.27199 14.2509 5.25 14.1784 5.25 14.1042C5.25 14.0048 5.28951 13.9094 5.35983 13.8391C5.43016 13.7688 5.52554 13.7292 5.625 13.7292Z",
    fill: "#C0B7D1",
    stroke: "#C0B7D1",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 18.9792C5.69917 18.9792 5.77167 19.0012 5.83334 19.0424C5.89501 19.0837 5.94307 19.1422 5.97145 19.2107C5.99984 19.2793 6.00726 19.3547 5.99279 19.4274C5.97832 19.5001 5.94261 19.567 5.89017 19.6194C5.83772 19.6719 5.7709 19.7076 5.69816 19.722C5.62542 19.7365 5.55002 19.7291 5.48149 19.7007C5.41297 19.6723 5.3544 19.6243 5.3132 19.5626C5.27199 19.5009 5.25 19.4284 5.25 19.3542C5.25 19.2548 5.28951 19.1594 5.35983 19.0891C5.43016 19.0188 5.52554 18.9792 5.625 18.9792Z",
    fill: "#C0B7D1",
    stroke: "#C0B7D1",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2110_98724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0.229248)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVioletCalendar);
export default __webpack_public_path__ + "static/media/violet-calendar.3ffacc0520882bfbdbca2ec502b75c3b.svg";
export { ForwardRef as ReactComponent };